import { Component, Input } from '@angular/core';

@Component({
  selector: 'nv-logo',
  template: require('./nv-logo.component.html'),
  styles: [require('./nv-logo.component.scss')],
})
export class NvLogoComponent {
  @Input() type: 'symbol' | 'wordmark';
}
